import { ContentMethodRichText } from "../../manage/methods"

export default {
  TASK: {
    key: "CompletionTask",
    fieldsData: {
      richtext: {
        placeholder: "Todo instructions..."
      }
    },
    getValues(content) {
      const values = { richtext: content != null ? content.task : undefined }
      return values
    },
    getSaveData(fieldsData) {
      const saveData = { task: fieldsData.richtext.value }
      return saveData
    },
    renderForm({ fieldsData }) {
      return (
        <ContentMethodRichText {...Object.assign({}, fieldsData.richtext)} />
      )
    }
  }
}
